module.exports = __webpack_public_path__ + "img/shoulder_width.a00263ad.png";